import type {EagColumn} from '../types/EagColumn';

export const getCellClassName = (column?: EagColumn) =>
  column?.wrapText ? 'block' : 'block truncate';
